import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';

import routes from '../../routes';
import config from '../../config';

import MobileLanding from './MobileLanding';
import MobileLogin from './MobileLogin';
import MobileForgotPassword from './MobileForgotPassword';
import MobileResetPassword from './MobileResetPassword';


const MobileEntrance = () => {
  return (
    <Page>
      <div id="content">
        <div className="event-title">
          <h4>
            Welcome to&nbsp;<br/>
            <strong>Novo Nordisk Know Your Insulin Virtual Launch</strong>
          </h4>
          <p>6<span>th</span> March 2021</p>
        </div>
        <Switch>
          <Route exact path={routes.root}>
            <MobileLanding />
          </Route>

          <Route exact path={routes.login}>
            <MobileLogin />
          </Route>

          <Route exact path={routes.forgotPassword}>
            <MobileForgotPassword />
          </Route>

          <Route exact path={routes.resetPassword}>
            <MobileResetPassword />
          </Route>
        </Switch>
      </div>
    </Page>
  );
}

const Page = styled.div`
  background: url(${config.assets.entrance.portrait});
  background-size: cover;
  background-position: top center;
  height: 100vh;
  width: 100vw;

  #content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;

    .event-title {
      background: rgba(255, 255, 255, 0.65);
      border-radius: 32px;
      width: 80%;
      margin: 3rem auto;
      margin-bottom: 1rem;
      padding: 16px 32px;
      text-align: center;
      color: #002060;
      font-weight: 600;
      border: 2px solid white;
      p {
        font-size: 20px;
        margin:0;
        span {
          font-size: 10px;
          vertical-align: top;
        }
      }
    }
  }
`

export default MobileEntrance;